import PropTypes from 'prop-types';
import PriceChangeIndicatorImpl from './price-change-indicator.js';
import MojitoCore from 'mojito/core';

/**
 * Renders a price change indicator (up/down arrows) based on old and new price comparison.
 *
 * @class PriceChangeIndicator
 * @memberof Mojito.Presentation.Components
 */

/**
 * `PriceChangeIndicator` component prop types.
 *
 * @property {number|string} [oldPrice] - Previous price (number or string).
 * @property {number|string} [newPrice] - Current price (number or string).
 *
 * @memberof Mojito.Presentation.Components.PriceChangeIndicator
 */
const propTypes = {
    oldPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    newPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default MojitoCore.Presentation.UIView(
    'PriceChangeIndicator',
    PriceChangeIndicatorImpl,
    propTypes
);
